// src/pages/LoginForgot/LoginForgot.jsx
import React, { useContext, useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import { RecoveryContext } from "../../components/forgotpassword/Forgotpassword";
import "./loginforgot.css";

export default function LoginForgot() {
  const [errors, setErrors] = useState("");

  // Pull only what exists in the secure context
  const {
    requestOTP,   // ask backend to generate & email OTP
    isFetching,   // loading state from provider
    setEmail,     // store email in context
    email,        // current email from context
    error,        // provider error (optional)
    setError,     // clear provider error (optional)
  } = useContext(RecoveryContext);

  // Use a controlled input to avoid remount/focus loss
  const [localEmail, setLocalEmail] = useState(email || "");
  useEffect(() => {
    // If context email changes elsewhere, keep input in sync
    if ((email || "") !== localEmail) setLocalEmail(email || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  const navigateToOtp = async () => {
    const enteredEmail = (localEmail || "").trim().toLowerCase();
    if (!enteredEmail) {
      setErrors("Please enter your email");
      return;
    }
    setErrors("");
    setError?.(null);

    // Mirror into context for next screens
    setEmail?.(enteredEmail);

    try {
      await requestOTP(enteredEmail);
      // Provider will set page="otp" on success. No manual navigation here.
    } catch (e) {
      setErrors(e?.response?.data?.error || "Could not start recovery.");
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setLocalEmail(v);
    setEmail?.(v);     // keep context updated
    setErrors("");
    setError?.(null);
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <Link to="/" className="logo link-style">
          <h1>Reset your password</h1>
        </Link>
        <p>Enter email of account you want to reset</p>
      </div>

      <div className="login-form">
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            className="input2"
            id="email"
            type="email"
            name="email"
            placeholder="Email"
            value={localEmail}
            onChange={handleChange}
            autoComplete="email"
            autoFocus
          />
          {/* show inline validation only when there is an error */}
          {!localEmail && errors && (
            <span className="error-message">Please enter an email</span>
          )}
        </div>

        <button
          className="login-button"
          type="button"
          onClick={navigateToOtp}
          disabled={isFetching}
        >
          {isFetching ? (
            <CircularProgress style={{ color: "white" }} size={18} />
          ) : (
            "Reset password"
          )}
        </button>

        {(errors || error) && (
          <span className="error-message">{errors || String(error)}</span>
        )}

        <div className="login-link1">
          <Link to="/login" style={{ textDecoration: "none" }}>
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
